import React, { useContext } from "react";
import { Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, } from "react-bootstrap";

const ModalComp = (props) => {

  const { modalTitle, modalHeaderClass = 'justify-content-start', modalBody, modalFooter, handleClose, show, isClosable = true, fullScreen, modalBGColor = "#00000052", ...other } = props;

  const modalStyle = {
    backgroundColor: modalBGColor,
  };

  if (modalBody !== undefined) {
    return (
      <>
        <Modal show={show} onHide={handleClose}  {...other} style={modalStyle} backdrop="static">
          {modalTitle !== undefined && <ModalHeader closeButton={isClosable} className={modalHeaderClass}>
            <ModalTitle>{(modalTitle)}</ModalTitle>
          </ModalHeader>}
          <ModalBody id='scrollableDiv'>
            {modalBody}
          </ModalBody>
          {modalFooter !== undefined && <ModalFooter>{modalFooter}</ModalFooter>}
        </Modal>
      </>
    );
  }
};

export default ModalComp;
